import { Injectable } from '@angular/core';

import type { Observable } from 'rxjs';
import { of } from 'rxjs';

import type { Assignment } from './assign-offers.facade';
import { AssignOffersFacade } from './assign-offers.facade';

@Injectable()
export class AssignOffersNewCandidateFacade extends AssignOffersFacade<{
  onSubmit: (
    jobsToDelete: Assignment[],
    jobsToUpdate: Assignment[],
    talentPoolsToDelete: Assignment[],
    talentPoolsToUpdate: Assignment[],
  ) => void;
}> {
  public dispatch(): Observable<boolean> {
    this.options.onSubmit(
      this.jobAssignmentsChanges.deleted,
      this.jobAssignmentsChanges.created.map(({ id }) => ({
        id,
        locationIds: this.selectedLocationsByOffer.get(id) || null,
      })),
      this.talentPoolAssignmentsChanges.deleted,
      this.talentPoolAssignmentsChanges.created.map(({ id }) => ({
        id,
      })),
    );
    return of(true);
  }
}
